module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia3_thumb-3c2bea0e24c2e248aa7cb65fbceaab3b.jpg";